import styled from 'styled-components';

export const Container = styled.div`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 12px;
	padding: 16px;
	width: 100%;
`;
